import {
  collection,
  query,
  orderBy,
  getDocs,
} from 'firebase/firestore'
import { db, isFirebaseConfigured } from './firebase'
import type { BoardMember } from '../types'

const BOARD_MEMBERS_COLLECTION = 'board_members'

// デフォルトの理事データ（Firestoreにデータがない場合のフォールバック）
// Firestoreに登録すればそちらが優先される。更新手順は docs/board-member-management.md 参照
const DEMO_BOARD_MEMBERS: BoardMember[] = [
  {
    id: 'shimizu',
    name: '清水 紀之',
    nameEn: 'Noriyuki Shimizu',
    title: '代表理事',
    company: '米大手IT企業出身（IT企業経営者）',
    description:
      'ITとITを取り巻くビジネスにかかわる皆さまが互いに学び合い、安心して力を発揮できる温かい場所をつくりたいと考えています。技術・知識を誠実に磨きながら信頼関係を育て、若手からベテランまで長く安心して活躍できる環境を広げていきます。そして日本社会のDX/AX推進に貢献する仲間を、心を込めて応援・支援していきます。',
    focusAreas: ['DX/AXの推進', '起業・事業開発', '技術戦略'],
    image: '/images/shimizu_.jpg',
    order: 10,
    linkedinUrl: 'https://www.linkedin.com/in/noriyuki-shimizu-2a949013/',
  },
  {
    id: 'tsuchiya',
    name: '土屋 亮',
    nameEn: 'Ryo Tsuchiya',
    title: '理事',
    company: '米大手IT企業出身（IT企業経営者・PMP）',
    description:
      'エンジニアとして長年培ってきた実装力と、米国IT企業で得たグローバル水準の開発・運用ノウハウを軸に、常にユーザーと事業価値に寄り添うシステム開発を実践してきました。技術者が安心して学び挑戦できるコミュニティを育てるとともに、最先端技術の知見を実務へ還元し、成果につながるスキル獲得と継続的なキャリア形成を支援します。',
    focusAreas: ['ソフトウェア開発', 'プロジェクト管理', '起業・事業開発'],
    image: '/images/tsuchiya_.jpg',
    order: 20,
    linkedinUrl: 'https://www.linkedin.com/in/ryo-tsuchiya/',
  },
  {
    id: 'murakami',
    name: '村上 智之',
    nameEn: 'Tomoyuki Murakami',
    title: '理事',
    company: 'データサイエンス企業（IT企業経営者）',
    description:
      'データサイエンティストとして最先端のデータ分析・機械学習プロジェクトに数多く携わるとともに、起業家・開発者として実務と事業の両面で経験を重ねてきました。AI／MLの実装から事業化までを一貫して担ってきた知見を活かし、実践的な学びと知識共有を通じてコミュニティの価値向上を図り、メンバー一人ひとりが安心して成長し、挑戦できる環境づくりに貢献していきます。',
    focusAreas: ['データサイエンス', 'AI/機械学習', '起業・事業開発'],
    image: '/images/murakami_.jpg',
    order: 30,
    linkedinUrl: 'https://www.linkedin.com/in/%E6%99%BA%E4%B9%8B-%E6%9D%91%E4%B8%8A-173522108/',
  },
  {
    id: 'takeda',
    name: '竹田 ひろ子',
    nameEn: 'Hiroko Takeda',
    title: '理事',
    company: '米大手IT企業出身',
    description:
      '米国大手IT企業での営業・マーケティングの知見、またビジネスコーチとしての人材開発の経験を結集し、起業家として新たな価値を創造しています。ITプロフェッショナルが時代の変化を捉え、常に学び続け、市場にさらなる価値を提供していくための成長と活躍を力強く支援していきます。',
    focusAreas: ['人材開発', 'マーケティング', '起業・事業開発'],
    image: '/images/meguro_.jpg',
    order: 40,
    linkedinUrl: 'https://www.linkedin.com/in/blackeye/',
  },
  {
    id: 'tsukamoto',
    name: '塚本 一輝',
    nameEn: 'Kazuki Tsukamoto',
    title: '理事',
    company: '大手監査法人出身（公認会計士・税理士）',
    description:
      '公認会計士として大手監査法人で上場企業から中小企業まで幅広い会計・監査業務に携わっておりました。現在は公認会計士だけではなく、税理士としても多くの法人・個人の皆様と伴走しており、その知見を活かして、会計・税務・財務の専門家として協会の健全かつ透明性の高い運営を実現し、会員の皆様が安心して利用できるビジネスインフラ整備に貢献していきます。',
    focusAreas: ['会計・監査', '税務', 'コーポレートガバナンス'],
    image: '/images/tsukamoto_.jpg',
    order: 50,
  },
  {
    id: 'kato',
    name: '加藤 扶美子',
    nameEn: 'Fumiko Kato',
    title: '監事',
    company: '大手監査法人出身（公認会計士・税理士）',
    description:
      '公認会計士・税理士として大手監査法人で豊富な経験を積み、監査・会計・税務の分野で高い専門性を持つ。監事として協会の業務執行を監査し、適正な運営と透明性の確保に貢献。財務面から協会の健全性を支える。',
    focusAreas: ['監査', '会計', '内部統制'],
    image: '/images/kato_.jpg',
    order: 60,
  },
  {
    id: 'iguchi',
    name: '井口 倫子',
    nameEn: 'Noriko Iguchi',
    title: '会長理事',
    company: '米大手IT企業出身',
    description:
      '複数の事業を立ち上げた起業家として、営業・マーケティング、顧客起点のDX／AX、業務改革、人材開発など幅広い分野で豊富な実績を積んできました。経営学修士。米国大手IT企業で培った経験を基盤に、グローバルな視点から日本のITビジネス・プロフェッショナルが進化し続ける環境を築くことを使命としています。本協会では、会員一人ひとりが専門性を高め、キャリアを広げる場であると同時に、賛助会員の皆さまと共に「未来を形づくる場」を創出していきます。人材の成長と組織の発展を両輪とし、ITビジネスの可能性を社会へ広げ、次世代へとつなげていくことを目指しています。',
    focusAreas: ['DX/AXソリューション事業開発', '営業・マーケティング', '起業', '人材開発'],
    image: '/images/iguchi_.jpg',
    order: 70,
  },
]

/**
 * 役員一覧を取得
 */
export async function getBoardMembers(): Promise<BoardMember[]> {
  // Firebase が設定されていない場合はデフォルトデータを返す
  if (!isFirebaseConfigured || !db) {
    console.log('📝 Firebase not configured, using default board members data')
    return DEMO_BOARD_MEMBERS
  }

  try {
    const q = query(
      collection(db, BOARD_MEMBERS_COLLECTION),
      orderBy('order', 'asc')
    )

    const snapshot = await getDocs(q)
    const members: BoardMember[] = []

    snapshot.forEach((doc) => {
      members.push({
        id: doc.id,
        ...doc.data(),
      } as BoardMember)
    })

    // Firestoreにデータがない場合はデフォルトデータを返す
    if (members.length === 0) {
      console.log('📝 No data in Firestore, using default board members data')
      return DEMO_BOARD_MEMBERS
    }

    return members
  } catch (error) {
    console.error('Error fetching board members:', error)
    // エラー時もデフォルトデータを返す（コンソールにはエラー出力済み）
    return DEMO_BOARD_MEMBERS
  }
}

